import { render } from "./TextareaVariables.vue?vue&type=template&id=cd6b03ca&scoped=true"
import script from "./TextareaVariables.vue?vue&type=script&lang=ts"
export * from "./TextareaVariables.vue?vue&type=script&lang=ts"

import "./TextareaVariables.vue?vue&type=style&index=0&id=cd6b03ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cd6b03ca"

export default script